module.exports = __webpack_public_path__ + "img/homePng.82b66414.png";